import i18next, * as i18n from 'i18next'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next, useTranslation } from 'react-i18next'

import { API_PATCH_UpdateUser } from '@/apis/auth.api'
import type { Option } from '@/components/Inputs/InputDropdown'
import bg_common from '@/locales/bg/common.json'
import bg_home from '@/locales/bg/home.json'
import bg_my_book from '@/locales/bg/my-book.json'
import bg_nps from '@/locales/bg/nps.json'
import bg_onboarding from '@/locales/bg/onboarding.json'
import bg_orders from '@/locales/bg/orders.json'
import bg_print_requests from '@/locales/bg/print-requests.json'
import bg_products from '@/locales/bg/products.json'
import bg_settings from '@/locales/bg/settings.json'
import bg_shop from '@/locales/bg/shop.json'
import da_common from '@/locales/da/common.json'
import da_home from '@/locales/da/home.json'
import da_my_book from '@/locales/da/my-book.json'
import da_nps from '@/locales/da/nps.json'
import da_onboarding from '@/locales/da/onboarding.json'
import da_orders from '@/locales/da/orders.json'
import da_print_requests from '@/locales/da/print-requests.json'
import da_products from '@/locales/da/products.json'
import da_settings from '@/locales/da/settings.json'
import da_shop from '@/locales/da/shop.json'
import de_common from '@/locales/de/common.json'
import de_home from '@/locales/de/home.json'
import de_my_book from '@/locales/de/my-book.json'
import de_nps from '@/locales/de/nps.json'
import de_onboarding from '@/locales/de/onboarding.json'
import de_orders from '@/locales/de/orders.json'
import de_print_requests from '@/locales/de/print-requests.json'
import de_products from '@/locales/de/products.json'
import de_settings from '@/locales/de/settings.json'
import de_shop from '@/locales/de/shop.json'
import el_common from '@/locales/el/common.json'
import el_home from '@/locales/el/home.json'
import el_my_book from '@/locales/el/my-book.json'
import el_nps from '@/locales/el/nps.json'
import el_onboarding from '@/locales/el/onboarding.json'
import el_orders from '@/locales/el/orders.json'
import el_print_requests from '@/locales/el/print-requests.json'
import el_products from '@/locales/el/products.json'
import el_settings from '@/locales/el/settings.json'
import el_shop from '@/locales/el/shop.json'
import en_au_common from '@/locales/en-AU/common.json'
import en_au_home from '@/locales/en-AU/home.json'
import en_au_my_book from '@/locales/en-AU/my-book.json'
import en_au_nps from '@/locales/en-AU/nps.json'
import en_au_onboarding from '@/locales/en-AU/onboarding.json'
import en_au_orders from '@/locales/en-AU/orders.json'
import en_au_print_requests from '@/locales/en-AU/print-requests.json'
import en_au_products from '@/locales/en-AU/products.json'
import en_au_settings from '@/locales/en-AU/settings.json'
import en_au_shop from '@/locales/en-AU/shop.json'
import en_gb_common from '@/locales/en-GB/common.json'
import en_gb_home from '@/locales/en-GB/home.json'
import en_gb_my_book from '@/locales/en-GB/my-book.json'
import en_gb_nps from '@/locales/en-GB/nps.json'
import en_gb_onboarding from '@/locales/en-GB/onboarding.json'
import en_gb_orders from '@/locales/en-GB/orders.json'
import en_gb_print_requests from '@/locales/en-GB/print-requests.json'
import en_gb_products from '@/locales/en-GB/products.json'
import en_gb_settings from '@/locales/en-GB/settings.json'
import en_gb_shop from '@/locales/en-GB/shop.json'
import en_us_common from '@/locales/en-US/common.json'
import en_us_home from '@/locales/en-US/home.json'
import en_us_my_book from '@/locales/en-US/my-book.json'
import en_us_nps from '@/locales/en-US/nps.json'
import en_us_onboarding from '@/locales/en-US/onboarding.json'
import en_us_orders from '@/locales/en-US/orders.json'
import en_us_print_requests from '@/locales/en-US/print-requests.json'
import en_us_products from '@/locales/en-US/products.json'
import en_us_settings from '@/locales/en-US/settings.json'
import en_us_shop from '@/locales/en-US/shop.json'
import es_common from '@/locales/es/common.json'
import es_home from '@/locales/es/home.json'
import es_my_book from '@/locales/es/my-book.json'
import es_nps from '@/locales/es/nps.json'
import es_onboarding from '@/locales/es/onboarding.json'
import es_orders from '@/locales/es/orders.json'
import es_print_requests from '@/locales/es/print-requests.json'
import es_products from '@/locales/es/products.json'
import es_settings from '@/locales/es/settings.json'
import es_shop from '@/locales/es/shop.json'
import fr_common from '@/locales/fr/common.json'
import fr_home from '@/locales/fr/home.json'
import fr_my_book from '@/locales/fr/my-book.json'
import fr_nps from '@/locales/fr/nps.json'
import fr_onboarding from '@/locales/fr/onboarding.json'
import fr_orders from '@/locales/fr/orders.json'
import fr_print_requests from '@/locales/fr/print-requests.json'
import fr_products from '@/locales/fr/products.json'
import fr_settings from '@/locales/fr/settings.json'
import fr_shop from '@/locales/fr/shop.json'
import hr_common from '@/locales/hr/common.json'
import hr_home from '@/locales/hr/home.json'
import hr_my_book from '@/locales/hr/my-book.json'
import hr_nps from '@/locales/hr/nps.json'
import hr_onboarding from '@/locales/hr/onboarding.json'
import hr_orders from '@/locales/hr/orders.json'
import hr_print_requests from '@/locales/hr/print-requests.json'
import hr_products from '@/locales/hr/products.json'
import hr_settings from '@/locales/hr/settings.json'
import hr_shop from '@/locales/hr/shop.json'
import hu_common from '@/locales/hu/common.json'
import hu_home from '@/locales/hu/home.json'
import hu_my_book from '@/locales/hu/my-book.json'
import hu_nps from '@/locales/hu/nps.json'
import hu_onboarding from '@/locales/hu/onboarding.json'
import hu_orders from '@/locales/hu/orders.json'
import hu_print_requests from '@/locales/hu/print-requests.json'
import hu_products from '@/locales/hu/products.json'
import hu_settings from '@/locales/hu/settings.json'
import hu_shop from '@/locales/hu/shop.json'
import it_common from '@/locales/it/common.json'
import it_home from '@/locales/it/home.json'
import it_my_book from '@/locales/it/my-book.json'
import it_nps from '@/locales/it/nps.json'
import it_onboarding from '@/locales/it/onboarding.json'
import it_orders from '@/locales/it/orders.json'
import it_print_requests from '@/locales/it/print-requests.json'
import it_products from '@/locales/it/products.json'
import it_settings from '@/locales/it/settings.json'
import it_shop from '@/locales/it/shop.json'
import lt_common from '@/locales/lt/common.json'
import lt_home from '@/locales/lt/home.json'
import lt_my_book from '@/locales/lt/my-book.json'
import lt_nps from '@/locales/lt/nps.json'
import lt_onboarding from '@/locales/lt/onboarding.json'
import lt_orders from '@/locales/lt/orders.json'
import lt_print_requests from '@/locales/lt/print-requests.json'
import lt_products from '@/locales/lt/products.json'
import lt_settings from '@/locales/lt/settings.json'
import lt_shop from '@/locales/lt/shop.json'
import pl_common from '@/locales/pl/common.json'
import pl_home from '@/locales/pl/home.json'
import pl_my_book from '@/locales/pl/my-book.json'
import pl_nps from '@/locales/pl/nps.json'
import pl_onboarding from '@/locales/pl/onboarding.json'
import pl_orders from '@/locales/pl/orders.json'
import pl_print_requests from '@/locales/pl/print-requests.json'
import pl_products from '@/locales/pl/products.json'
import pl_settings from '@/locales/pl/settings.json'
import pl_shop from '@/locales/pl/shop.json'
import pt_br_common from '@/locales/pt-br/common.json'
import pt_br_home from '@/locales/pt-br/home.json'
import pt_br_my_book from '@/locales/pt-br/my-book.json'
import pt_br_nps from '@/locales/pt-br/nps.json'
import pt_br_onboarding from '@/locales/pt-br/onboarding.json'
import pt_br_orders from '@/locales/pt-br/orders.json'
import pt_br_print_requests from '@/locales/pt-br/print-requests.json'
import pt_br_products from '@/locales/pt-br/products.json'
import pt_br_settings from '@/locales/pt-br/settings.json'
import pt_br_shop from '@/locales/pt-br/shop.json'
import pt_common from '@/locales/pt/common.json'
import pt_home from '@/locales/pt/home.json'
import pt_my_book from '@/locales/pt/my-book.json'
import pt_nps from '@/locales/pt/nps.json'
import pt_onboarding from '@/locales/pt/onboarding.json'
import pt_orders from '@/locales/pt/orders.json'
import pt_print_requests from '@/locales/pt/print-requests.json'
import pt_products from '@/locales/pt/products.json'
import pt_settings from '@/locales/pt/settings.json'
import pt_shop from '@/locales/pt/shop.json'
import ro_common from '@/locales/ro/common.json'
import ro_home from '@/locales/ro/home.json'
import ro_my_book from '@/locales/ro/my-book.json'
import ro_nps from '@/locales/ro/nps.json'
import ro_onboarding from '@/locales/ro/onboarding.json'
import ro_orders from '@/locales/ro/orders.json'
import ro_print_requests from '@/locales/ro/print-requests.json'
import ro_products from '@/locales/ro/products.json'
import ro_settings from '@/locales/ro/settings.json'
import ro_shop from '@/locales/ro/shop.json'
import sv_common from '@/locales/sv/common.json'
import sv_home from '@/locales/sv/home.json'
import sv_my_book from '@/locales/sv/my-book.json'
import sv_nps from '@/locales/sv/nps.json'
import sv_onboarding from '@/locales/sv/onboarding.json'
import sv_orders from '@/locales/sv/orders.json'
import sv_print_requests from '@/locales/sv/print-requests.json'
import sv_products from '@/locales/sv/products.json'
import sv_settings from '@/locales/sv/settings.json'
import sv_shop from '@/locales/sv/shop.json'
import tl_common from '@/locales/tl/common.json'
import tl_home from '@/locales/tl/home.json'
import tl_my_book from '@/locales/tl/my-book.json'
import tl_nps from '@/locales/tl/nps.json'
import tl_onboarding from '@/locales/tl/onboarding.json'
import tl_orders from '@/locales/tl/orders.json'
import tl_print_requests from '@/locales/tl/print-requests.json'
import tl_products from '@/locales/tl/products.json'
import tl_settings from '@/locales/tl/settings.json'
import tl_shop from '@/locales/tl/shop.json'
import tr_common from '@/locales/tr/common.json'
import tr_home from '@/locales/tr/home.json'
import tr_my_book from '@/locales/tr/my-book.json'
import tr_nps from '@/locales/tr/nps.json'
import tr_onboarding from '@/locales/tr/onboarding.json'
import tr_orders from '@/locales/tr/orders.json'
import tr_print_requests from '@/locales/tr/print-requests.json'
import tr_products from '@/locales/tr/products.json'
import tr_settings from '@/locales/tr/settings.json'
import tr_shop from '@/locales/tr/shop.json'
import type { UserT } from '@/stores/user.store'
import { useStoreUser } from '@/stores/user.store'

import { getBrand } from './brand.util'

const ld = new LanguageDetector()
const LANGS = [
  'en-AU',
  'en-GB',
  'en-US',
  'es',
  'fr',
  'de',
  'it',
  'lt',
  'pl',
  'pt',
  'pt-BR',
  'hr',
  'ro',
  'sv',
  'tr',
  'tl',
  'hu',
  'bg',
  'el',
  'da',
] as const

export type Lang = (typeof LANGS)[number]

export const isLang = (code: string | null | undefined): code is Lang =>
  !!code && (LANGS as readonly string[]).includes(code)

export const externalLangToAppLang = (code: string): Lang | null => {
  const map: Record<string, Lang> = {
    en: 'en-US',
    gb: 'en-GB',
    es: 'es',
    fr: 'fr',
    de: 'de',
    it: 'it',
    eu: 'lt',
    pl: 'pl',
    pt: 'pt-BR',
    la: 'es',
    ca: 'en-US',
    au: 'en-AU',
    nz: 'en-US',
    hr: 'hr',
    ro: 'ro',
    sv: 'sv',
    tr: 'tr',
    tl: 'tl',
    hu: 'hu',
    bg: 'bg',
    el: 'el',
    da: 'da',
  }
  return map[code] ?? null
}

export const normalizeLang = (code: string | null | undefined): Lang => {
  if (isLang(code)) return code
  const base = code?.split('-')[0]?.toLowerCase()
  if (!base) return 'en-US'
  if (base === 'en') return 'en-US'
  if (isLang(base)) return base
  return 'en-US'
}

const resources = {
  de: {
    common: de_common,
    home: de_home,
    my_book: de_my_book,
    onboarding: de_onboarding,
    orders: de_orders,
    print_requests: de_print_requests,
    products: de_products,
    settings: de_settings,
    shop: de_shop,
    nps: de_nps,
  },
  'en-AU': {
    common: en_au_common,
    home: en_au_home,
    my_book: en_au_my_book,
    onboarding: en_au_onboarding,
    orders: en_au_orders,
    print_requests: en_au_print_requests,
    products: en_au_products,
    settings: en_au_settings,
    shop: en_au_shop,
    nps: en_au_nps,
  },
  'en-GB': {
    common: en_gb_common,
    home: en_gb_home,
    my_book: en_gb_my_book,
    onboarding: en_gb_onboarding,
    orders: en_gb_orders,
    print_requests: en_gb_print_requests,
    products: en_gb_products,
    settings: en_gb_settings,
    shop: en_gb_shop,
    nps: en_gb_nps,
  },
  'en-US': {
    common: en_us_common,
    home: en_us_home,
    my_book: en_us_my_book,
    onboarding: en_us_onboarding,
    orders: en_us_orders,
    print_requests: en_us_print_requests,
    products: en_us_products,
    settings: en_us_settings,
    shop: en_us_shop,
    nps: en_us_nps,
  },
  es: {
    common: es_common,
    home: es_home,
    my_book: es_my_book,
    onboarding: es_onboarding,
    orders: es_orders,
    print_requests: es_print_requests,
    products: es_products,
    settings: es_settings,
    shop: es_shop,
    nps: es_nps,
  },
  fr: {
    common: fr_common,
    home: fr_home,
    my_book: fr_my_book,
    onboarding: fr_onboarding,
    orders: fr_orders,
    print_requests: fr_print_requests,
    products: fr_products,
    settings: fr_settings,
    shop: fr_shop,
    nps: fr_nps,
  },
  it: {
    common: it_common,
    home: it_home,
    my_book: it_my_book,
    onboarding: it_onboarding,
    orders: it_orders,
    print_requests: it_print_requests,
    products: it_products,
    settings: it_settings,
    shop: it_shop,
    nps: it_nps,
  },
  lt: {
    common: lt_common,
    home: lt_home,
    my_book: lt_my_book,
    onboarding: lt_onboarding,
    orders: lt_orders,
    print_requests: lt_print_requests,
    products: lt_products,
    settings: lt_settings,
    shop: lt_shop,
    nps: lt_nps,
  },
  'pt-BR': {
    common: pt_br_common,
    home: pt_br_home,
    my_book: pt_br_my_book,
    onboarding: pt_br_onboarding,
    orders: pt_br_orders,
    print_requests: pt_br_print_requests,
    products: pt_br_products,
    settings: pt_br_settings,
    shop: pt_br_shop,
    nps: pt_br_nps,
  },
  pl: {
    common: pl_common,
    home: pl_home,
    my_book: pl_my_book,
    onboarding: pl_onboarding,
    orders: pl_orders,
    print_requests: pl_print_requests,
    products: pl_products,
    settings: pl_settings,
    shop: pl_shop,
    nps: pl_nps,
  },
  pt: {
    common: pt_common,
    home: pt_home,
    my_book: pt_my_book,
    onboarding: pt_onboarding,
    orders: pt_orders,
    print_requests: pt_print_requests,
    products: pt_products,
    settings: pt_settings,
    shop: pt_shop,
    nps: pt_nps,
  },
  hr: {
    common: hr_common,
    home: hr_home,
    my_book: hr_my_book,
    onboarding: hr_onboarding,
    orders: hr_orders,
    print_requests: hr_print_requests,
    products: hr_products,
    settings: hr_settings,
    shop: hr_shop,
    nps: hr_nps,
  },
  ro: {
    common: ro_common,
    home: ro_home,
    my_book: ro_my_book,
    onboarding: ro_onboarding,
    orders: ro_orders,
    print_requests: ro_print_requests,
    products: ro_products,
    settings: ro_settings,
    shop: ro_shop,
    nps: ro_nps,
  },
  sv: {
    common: sv_common,
    home: sv_home,
    my_book: sv_my_book,
    onboarding: sv_onboarding,
    orders: sv_orders,
    print_requests: sv_print_requests,
    products: sv_products,
    settings: sv_settings,
    shop: sv_shop,
    nps: sv_nps,
  },
  tr: {
    common: tr_common,
    home: tr_home,
    my_book: tr_my_book,
    onboarding: tr_onboarding,
    orders: tr_orders,
    print_requests: tr_print_requests,
    products: tr_products,
    settings: tr_settings,
    shop: tr_shop,
    nps: tr_nps,
  },
  tl: {
    common: tl_common,
    home: tl_home,
    my_book: tl_my_book,
    onboarding: tl_onboarding,
    orders: tl_orders,
    print_requests: tl_print_requests,
    products: tl_products,
    settings: tl_settings,
    shop: tl_shop,
    nps: tl_nps,
  },
  hu: {
    common: hu_common,
    home: hu_home,
    my_book: hu_my_book,
    onboarding: hu_onboarding,
    orders: hu_orders,
    print_requests: hu_print_requests,
    products: hu_products,
    settings: hu_settings,
    shop: hu_shop,
    nps: hu_nps,
  },
  bg: {
    common: bg_common,
    home: bg_home,
    my_book: bg_my_book,
    onboarding: bg_onboarding,
    orders: bg_orders,
    print_requests: bg_print_requests,
    products: bg_products,
    settings: bg_settings,
    shop: bg_shop,
    nps: bg_nps,
  },
  el: {
    common: el_common,
    home: el_home,
    my_book: el_my_book,
    onboarding: el_onboarding,
    orders: el_orders,
    print_requests: el_print_requests,
    products: el_products,
    settings: el_settings,
    shop: el_shop,
    nps: el_nps,
  },
  da: {
    common: da_common,
    home: da_home,
    my_book: da_my_book,
    onboarding: da_onboarding,
    orders: da_orders,
    print_requests: da_print_requests,
    products: da_products,
    settings: da_settings,
    shop: da_shop,
    nps: da_nps,
  },
}

type NS = keyof (typeof resources)['en-US']

const brand = getBrand()

export const detectLang = (): Lang => {
  if (typeof window === 'undefined') return 'en-US'
  return normalizeLang(window.localStorage.getItem('i18nextLng') || window.navigator.language)
}

export default i18n
  .use(initReactI18next)
  .use(ld)
  .init({
    resources,
    defaultNS: 'common',
    lng: detectLang(),
    fallbackLng: 'en-US',
    interpolation: {
      escapeValue: false,
      defaultVariables: {
        brand: brand.name,
        website: brand.website,
      },
    },
  })

export const t = i18next.t
export const useT = (trans: NS) => useTranslation(trans).t as (key: string, options?: any) => string
export const getL = () => i18next.language || window.localStorage.i18nextLng
export const applyLang = (lang: Lang) => i18n.changeLanguage(lang)
export const postL = async (lang: Lang, user?: UserT | null) => {
  if (user) {
    await API_PATCH_UpdateUser({ locale: lang })
  }
  await i18n.changeLanguage(lang)
  window.location.reload()
}

const LOC = {
  'en-AU': 'en-AU',
  'en-GB': 'en-GB',
  'en-US': 'en-US',
  es: 'es',
  fr: 'fr',
  de: 'de',
  it: 'it',
  lt: 'lt',
  pl: 'pl',
  pt: 'pt',
  'pt-BR': 'pt-BR',
  hr: 'hr',
  ro: 'ro',
  sv: 'sv',
  tr: 'tr',
  tl: 'tl',
  hu: 'hu',
  bg: 'bg',
  el: 'el',
  da: 'da',
}
export const getLocale = (): string => LOC[normalizeLang(useStoreUser.getState().user?.locale || detectLang())]

export const LANG_OPTIONS: Option[] = [
  { value: 'en-US', label: 'English (US)' },
  { value: 'en-GB', label: 'English (GB)' },
  { value: 'en-AU', label: 'English (AU)' },
  { value: 'es', label: 'Español' },
  { value: 'fr', label: 'Français' },
  { value: 'de', label: 'Deutsch' },
  { value: 'it', label: 'Italiano' },
  { value: 'lt', label: 'Lietuvių' },
  { value: 'pl', label: 'Polski' },
  { value: 'pt', label: 'Português' },
  { value: 'pt-BR', label: 'Português (Brasil)' },
  { value: 'hr', label: 'Hrvatski' },
  { value: 'ro', label: 'Română' },
  { value: 'sv', label: 'Svenska' },
  { value: 'tr', label: 'Türkçe' },
  { value: 'tl', label: 'Taglish' },
  { value: 'hu', label: 'Magyar' },
  { value: 'bg', label: 'Български' },
  { value: 'el', label: 'Ελληνικά' },
  { value: 'da', label: 'Dansk' },
]

export const findLangOption = () => {
  return LANG_OPTIONS.find((option) => option.value === getLocale())
}

export const getAPILocale = (): string => {
  const lang = normalizeLang(useStoreUser.getState().user?.locale || detectLang())
  const mapping: Record<Lang, string> = {
    'en-US': 'en',
    'en-GB': 'gb',
    'en-AU': 'au',
    es: 'es',
    fr: 'fr',
    de: 'de',
    it: 'it',
    lt: 'eu',
    pl: 'pl',
    pt: 'pt',
    'pt-BR': 'br',
    hr: 'hr',
    ro: 'eu',
    sv: 'sv',
    tr: 'tr',
    tl: 'en',
    hu: 'eu',
    bg: 'eu',
    el: 'eu',
    da: 'eu',
  }
  return mapping[lang] || 'en'
}

// Human-readable language name for prompting an LLM to reply in the user's
// language. Prefer this over getAPILocale() for AI text — the API codes are
// ambiguous (e.g. 'eu' for Lithuanian, 'gb'/'au' for English variants).
export const getLanguageName = (): string => {
  const lang = normalizeLang(useStoreUser.getState().user?.locale || detectLang())
  const names: Record<Lang, string> = {
    'en-US': 'English (US)',
    'en-GB': 'English (UK)',
    'en-AU': 'English (Australian)',
    es: 'Spanish',
    fr: 'French',
    de: 'German',
    it: 'Italian',
    lt: 'Lithuanian',
    pl: 'Polish',
    pt: 'European Portuguese (pt-PT)',
    'pt-BR': 'Brazilian Portuguese',
    hr: 'Croatian',
    ro: 'Romanian',
    sv: 'Swedish',
    tr: 'Turkish',
    tl: 'Taglish (Tagalog-English, Philippines)',
    hu: 'Hungarian',
    bg: 'Bulgarian',
    el: 'Greek',
    da: 'Danish',
  }
  return names[lang] || 'English (US)'
}
